module.exports = __webpack_public_path__ + "static/media/pengaturan.84398e83.png";